import { useAppSelector } from "@app/hooks"
import useGeoProvider from "@shared/GeoProvider"

// Пустая лента объясняет, где пусто, и сразу предлагает, куда переключиться
export default function EmptyFeed() {
  const city = useAppSelector(state => state.filter.city)
  const [, setLocation] = useGeoProvider()

  const btn: React.CSSProperties = {
    padding: "10px 18px", borderRadius: 100, border: "1px solid var(--borders)",
    background: "transparent", color: "var(--primary-text)", fontSize: 15, cursor: "pointer",
  }
  return (
    <div style={{ textAlign: "center", padding: "48px 16px", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
      <h2 style={{ margin: 0 }}>{city ? `В городе ${city} по этим фильтрам событий нет` : "По этим фильтрам событий нет"}</h2>
      <p style={{ margin: 0, color: "var(--secondary-text)" }}>Попробуйте другой город, дату или категорию.</p>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
        {city !== "Москва" && (
          <button style={btn} onClick={() => setLocation({ city: "Москва", region: "Москва", latitude: 55.7558, longitude: 37.6173, source: "manual" })}>
            Показать Москву
          </button>
        )}
        {city && (
          <button style={btn} onClick={() => setLocation({ city: "Вся Россия", region: "Россия", latitude: 0, longitude: 0, source: "manual" })}>
            Вся Россия
          </button>
        )}
      </div>
    </div>
  )
}
